// src/components/Header.tsx
import React from "react";

export default function Header() {
  return (
   
    
    <header className="bg-white-500 text-white shadow-md">
      <div className="max-w-6xl mx-auto flex items-center justify-between p-4">
        <div className="flex items-center gap-3">
         <img
  src="/logo.png"
  alt="PollChimp logo"
  className="
    rounded-full bg-white p-1
    w-[clamp(64px,14vw,240px)]
    h-auto
  "
/>


        </div>
      </div>
    </header>
  );
}

